import { Component } from "@angular/core";

@Component({
    selector: "npi-not-found",
    template: " <h1>Pagina niet gevonden</h1> ",
    standalone: false
})
export class NotFoundComponent {}
